import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  delete_icon,
  edit_icon,
  search_icon,
  view_icon,
} from "../../../assets/imgs";
import { Table } from "../../../components/Table/Table";
import { sitesCompanyList } from "../../redux/api/dummyJson";
import { get, post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import { toast } from "react-toastify";
import moment from "moment/moment";
import FavoriteIcon from "@mui/icons-material/Favorite";

const CompanySites = () => {
  const navigate = useNavigate();
  const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));

  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);

  const [pagination, setPagination] = useState(1);

  const [popup, setPopup] = useState(false);
  const [search, setSearch] = useState("");

  const handleStatus = (id) => {
    get(URL.SITE_STATUS + id)
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);
          getSiteList("");
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  // Site Name, Site address and site location with auto create  (date & time) and created by

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "sno",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },

      {
        Header: "Site Name",
        accessor: "site_name",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex flex-column gap-2">
              <p>{value}</p>
            </div>
          );
        },
      },
      {
        Header: "Site Address",
        accessor: "site_address",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex flex-column gap-2">
              <p>{value}</p>
            </div>
          );
        },
      },
      {
        Header: "Site location",
        accessor: "site_location",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Created By",
        accessor: "created_by",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Date and Time",
        accessor: "created_at",
        Cell: ({ value, row }) => {
          return <p>{value ? moment(value).format("DD-MM-YYYY") : "-"}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  if (
                    givenpermissions?.includes("CAN-Status-KNF_COMPANY_SITE")
                  ) {
                    handleStatus(row.original.id);
                  }
                }}
                className={`${
                  value ? "active-btn" : "deactive-btn"
                } border-0 f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 fs-xxl-18 ${
                  givenpermissions?.includes("CAN-Status-KNF_COMPANY_SITE")
                    ? ""
                    : "opacity-50"
                }`}
              >
                {value ? "Active" : "De-active"}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Device Status",
        accessor: "device_status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button className={`border-0 toggle-btn cust-btn `}>
                {value == 1 ? (
                  <div>
                    <FavoriteIcon className="green" />
                  </div>
                ) : (
                  <div>
                    <FavoriteIcon className="red" />
                  </div>
                )}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Service Status",
        accessor: "service_status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button className={`border-0 toggle-btn cust-btn `}>
                {value == 1 ? (
                  <div>
                    <FavoriteIcon className="green" />
                  </div>
                ) : (
                  <div>
                    <FavoriteIcon className="red" />
                  </div>
                )}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Description",
        accessor: "service_error",
        Cell: ({ value, row }) => {
          return <div className="d-flex flex-column gap-2">{value}</div>;
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc gap-1">
                {givenpermissions?.includes("CAN-View-KNF_COMPANY_SITE") && (
                  <button
                    onClick={() => {
                      navigate("/company-sites-view", {
                        state: { type: "view", data: row.original },
                      });
                      // AdminView(row.original.id, "view");
                    }}
                    className="cust-btn "
                  >
                    <img src={view_icon} alt="" className=" edit-btn " />
                  </button>
                )}
                {givenpermissions?.includes("CAN-Edit-KNF_COMPANY_SITE") && (
                  <button
                    onClick={() => {
                      navigate("/company-sites-view", {
                        state: { type: "edit", data: row.original },
                      });
                      // AdminView(row.original.id, "edit");
                    }}
                    className="cust-btn "
                  >
                    <img src={edit_icon} alt="" className=" edit-btn " />
                  </button>
                )}
                {/* {givenpermissions?.includes("CAN-Delete-KNF_COMPANY_SITE") && (
                  <button onClick={() => setPopup(true)} className="cust-btn ">
                    <img src={delete_icon} alt="" className=" edit-btn " />
                  </button>
                )} */}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [page]
  );

  const getSiteList = (search_) => {
    let formdata = new FormData();
    formdata.append("search", search_);
    formdata.append("knf_type", 1);
    setSearch(search_);
    post(URL.SITE_LISTS, formdata)
      .then((res) => {
        if (res?.status == "success") {
          setList(res?.lists);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getSiteList("");
  }, []);

  return (
    <div className="dashRightView ">
      <div className="d-flex ac-jb mt-3">
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total:{list?.length}
        </h2>
        <div className="d-flex gap-3">
          <div className="search-input">
            <input
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
              onChange={(e) => getSiteList(e.target.value)}
              value={search}
            />
            <img src={search_icon} className="search" />
          </div>

          {givenpermissions?.includes("CAN-Add-KNF_COMPANY_SITE") && (
            <button
              onClick={() =>
                navigate("/company-sites-view", { state: { type: "add" } })
              }
              className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn "
            >
              {" "}
              + Add Sites
            </button>
          )}
        </div>
      </div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={list ?? []}
        show={true}
      />
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setPopup(false)} className="add-btn w-40">
                Yes
              </button>
              <button
                onClick={() => {
                  setPopup(false);
                  // logout();
                }}
                className="back-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CompanySites;
